import { anim, prog, pv, stagger } from '../../../motion'
import { BeamBands, Count, FitIcon } from '../../../primitives'
import { Line } from '../../../v2/kit'
import { useCopy } from '../../i18n'
import { DIMS, SCORE, fitOf } from '../copy'

const FOCUS = DIMS.findIndex((d) => d.key === 'math')

// Der Report baut sich auf, dann rückt er zur Seite und eine Zeile wird zum Interview-Hinweis
export default function DemoReport() {
  const c = useCopy('matching')
  const dims = useCopy('dims')

  return (
    <div className='cin-full'>
      <div className='dm-report-head'>
        <Line at={[0, 0.06]} className='cin-eyebrow'>
          {c.eyebrow}
        </Line>
        <div className='dm-swap'>
          <Line at={[0, 0.08]} out={[0.48, 0.54]} className='cin-title'>
            {c.title}
          </Line>
          <Line at={[0.54, 0.6]} className='cin-title'>
            {c.detailTitle}
          </Line>
        </div>
      </div>

      <div className='dm-report' style={prog([0.48, 0.6])}>
        <div
          className='dm-report__card'
          style={anim({ at: [0.02, 0.1], y: 80 })}
        >
          <div className='dm-report__top'>
            <div className='dm-report__name'>{c.report}</div>
            <div className='dm-report__legend'>
              <span>
                <i className='dm-dot' />
                {c.person}
              </span>
              <span>
                <i
                  className='cin-swatch'
                  style={{ background: 'rgb(167 247 231)' }}
                />
                {c.target}
              </span>
              <span>
                <i
                  className='cin-swatch'
                  style={{ background: 'rgb(253 218 148)' }}
                />
                {c.tolerance}
              </span>
            </div>
          </div>

          {DIMS.map((d, row) => {
            const focus = row === FOCUS
            return (
              <div
                key={d.key}
                className='dm-report__row'
                style={
                  focus
                    ? pv('h', [0.56, 0.62])
                    : {
                        ...pv('h', [0.56, 0.62]),
                        opacity: 'calc(1 - 0.65 * var(--h))'
                      }
                }
              >
                <div className='dm-report__label'>
                  {dims[d.key]}
                  {d.must && <span className='dm-must'>{c.must}</span>}
                </div>
                <div className='dm-report__track'>
                  <BeamBands
                    ideal={d.ideal}
                    trans={d.trans}
                    at={stagger(0.08, 0.03, 0.1, row)}
                  />
                  <div
                    className='cin-reason__pin'
                    style={{
                      ...prog(stagger(0.18, 0.03, 0.12, row)),
                      left: `calc(var(--p) * ${d.person}%)`
                    }}
                  >
                    <div className='dm-report__marker' />
                  </div>
                </div>
                <div
                  className='dm-report__fit'
                  style={anim({
                    at: stagger(0.3, 0.03, 0.05, row),
                    s: 0.3,
                    y: 0
                  })}
                >
                  <FitIcon fit={fitOf(d)} size={26} />
                </div>
                {focus && <div className='dm-report__ring' />}
              </div>
            )
          })}

          <div
            className='dm-report__score'
            style={anim({ at: [0.36, 0.42], y: 30 })}
          >
            <div>
              <div className='dm-report__score-label'>{c.score}</div>
              <div className='dm-report__note'>{c.note}</div>
            </div>
            <div className='dm-report__score-value'>
              <Count to={SCORE} at={[0.38, 0.48]} className='dm-report__num' />
              <span className='dm-report__pill'>{c.scoreLabel}</span>
            </div>
          </div>
        </div>
      </div>

      <div className='dm-detail'>
        <div
          className='dm-detail__dim'
          style={anim({ at: [0.58, 0.64], x: 60, y: 0 })}
        >
          <FitIcon fit='mid' size={28} />
          <span>{dims.math}</span>
        </div>
        <Line at={[0.6, 0.66]} y={20} className='dm-detail__text'>
          {c.detailText}
        </Line>
        {c.hints.map((h, i) => (
          <div
            key={h.title}
            className={`dm-hint dm-hint--${i}`}
            style={anim({ at: stagger(0.66, 0.06, 0.08, i), x: 80, y: 0 })}
          >
            <span className='dm-hint__icon'>{h.icon}</span>
            <div>
              <div className='dm-hint__title'>{h.title}</div>
              <div className='dm-hint__text'>{h.text}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
